import { t } from "i18next";
import {
  BookingVehicleInfoCardProps,
  ChosenOptions,
  VehicleSpecsCardProps,
} from "./BookingVehicleInfoCard.props";
import { Dialog } from "@mui/material";
import i18n from "../../../config/i18n";
import AppButton from "../../UI/AppButtons";
import { useTranslation } from "react-i18next";
import CarDetailsPopup from "./CarDetailsPopup";
import InfoIcon from "@mui/icons-material/Info";
import { createTheme } from "@mui/material/styles";
import { useSearchParams } from "react-router-dom";
import { Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { formatTheme } from "../../../config/MuiColorThemes";
import BookingGetters from "../../../store/onlineBooking/getters";
import { VehicleSpecification } from "../VehicleSpecification/VehicleSpecification";
import { formatPriceWithCurrencySymbol } from "../../../helpers/getPriceWithCurrencySymbol";

function VehicleCardPitView({
  status = "Unavailable",
  vehicleInternationalCode,
  isNotclickedEdit,
  isVehicleUnavQuot,
  setIsLoading = () => {},
  setIsVehicleUnavQuot = () => {},
  updateTotalCardHeightMobile,
  ...VehicleDetails
}: BookingVehicleInfoCardProps) {
  const currency = BookingGetters.getCurrency();
  const ReservationDetails = BookingGetters.getBookingDetails();

  // const [selectedImage] = useState<number>(0);
  const [selectedImage, setSelectedImage] = useState(0);
  const [scalapayWidgetVisible, setScalapayWidgetVisible] = useState(false);
  const { t: translate } = useTranslation();
  const [startDate] = useState(
    new Date(ReservationDetails.pickUpDateAndTime || Date.now())
  );

  const [endDate] = useState(
    new Date(ReservationDetails.dropOffDateAndTime || Date.now())
  );
  const [discount, setDiscount] = useState(
    (100 - VehicleDetails.discount) / 100
  );
  const urlParams = new URLSearchParams(window.location.search);
  const isFromShareLink = urlParams.get("vehicleInternationalCode");
  const startDateUTC = new Date(
    Date.UTC(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate(),
      startDate.getHours()
    )
  );

  const endDateUTC = new Date(
    Date.UTC(
      endDate.getFullYear(),
      endDate.getMonth(),
      endDate.getDate(),
      endDate.getHours()
    )
  );

  const differenceInHour =
    (endDateUTC.getTime() - startDateUTC.getTime()) / (1000 * 60 * 60);

  const approximateDays = Math.ceil(differenceInHour / 24);
  const [pricePerDay] = useState(
    parseFloat(VehicleDetails.priceDetails.payNow.toString()) /
      (approximateDays == 0 ? 1 : approximateDays)
  );
  const [actualPrice] = useState(
    VehicleDetails.reservationSourcePayLater == "true"
      ? parseFloat(VehicleDetails?.actualPrice?.toString()) /
          (approximateDays == 0 ? 1 : approximateDays)
      : (parseFloat(VehicleDetails?.actualPrice?.toString()) * discount) /
          (approximateDays == 0 ? 1 : approximateDays)
  );
  const [totalPrice, setTotalPrice] = useState<number>(
    VehicleDetails.reservationSourcePayLater == "true"
      ? parseFloat(VehicleDetails.priceDetails.payNow)
      : parseFloat(VehicleDetails.priceDetails.payNow) * discount
  );
  const [totalPricePerDay, setTotalPricePerDay] = useState(pricePerDay);
  const appSettings = BookingGetters.getAppSettings();

  const isGretaUi = appSettings?.isGretaBookingNewUi;
  const [showInfo, setShowInfo] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const toogleVehicleInfoCardShowingStatus = () => {
    if (appSettings?.showAllDetailsOfVehicleCardInInfoBtn) {
      scrollToTop();
      setOpenModal((prev) => !prev);
    } else {
      setShowInfo(!showInfo);
    }
  };
  const [modalTechnicalDataContent, setModalTechnicalDataContent] =
    useState<string>("");

  const [modalDeductibleDepositContent, setModalDeductibleDepositContent] =
    useState<string>("");

  const [closeInfo, setCloseInfo] = useState<string>("");
  const [vehicleCancelMsgLabel, setVehicleCancelMsgLabel] =
    useState<String>("");
  const lang = i18n.language;
  const textResource = BookingGetters.getTextResourceDetailsBasedOnLang();
  const data = textResource?.[lang]?.flatMap((item) => item.data || []) || [];
  const [showReservationCancelMessage, setShowReservationCancelMessage] =
    useState<boolean>(false);
  const [vehicleInfoLabel, setVehicleInfoLabel] = useState<string>("");
  const [selectVehicleLabel, setSelectVehicleLabel] = useState<string>("");
  const [notAllowBookEndUserLabel, setNotAllowBookEndUserLabel] =
    useState<String>("");
  const [groupFromTextResource, setGroupFromTextResource] =
    useState<string>("");
  const [oohText, setOohText] = useState<string>("");
  const [includeText, setIncludeText] = useState<string>("");
  const [vehicleLimitedAvailability, setVehicleLimitedAvailability] =
    useState<string>("");
  const [deliverySurchargeLabel, setDeliverySurchargeLabel] =
    useState<string>("");
  const [returnSurchargeLabel, setReturnSurchargeLabel] = useState<string>("");
  const [isIncludedValue, setIsIncludedValue] = useState<string[]>([]);
  const [isNonIncludedValue, setIsNonIncludedValue] = useState<string[]>([]);
  const [inCludedTitle, setInCludedTitle] = useState<string>("");
  const [nonInCludedTitle, setNonInCludedTitle] = useState<string>("");
  const isReservedAreaUser = !!localStorage.getItem("userID");

  useEffect(() => {
    const vehicleCancellationMsg = data.find(
      (item) => item.key === "vehicleCancelMessage"
    );
    const closeInfoData = data.find((item) => item.key === "closeInfoLabel");
    const selectVehicleLabelData = data.find(
      (item) => item.key === "SelectVehicleLabel"
    );

    const vehicleInfoLabelData = data.find(
      (item) => item.key === "informationLabel"
    );
    setVehicleInfoLabel(vehicleInfoLabelData ? vehicleInfoLabelData.body : "");
    const YoungDriverTextData = data.find(
      (item) => item.key === "VehicleYoungDriverFeeLabel"
    );
    const notAllowBookEndUserData = data.find(
      (item) => item.key === "NotAllowBookEndUserLabel"
    );
    const groupFromTextResourceData =
      vehicleInternationalCode &&
      data.find((item) => item.key === vehicleInternationalCode);

    const modalTechnicalDataContentData = data.find(
      (item) => item.key === "modalTechnicalDataContent"
    );
    setModalTechnicalDataContent(
      modalTechnicalDataContentData ? modalTechnicalDataContentData.body : ""
    );

    const modalDeductibleDepositData = data.find(
      (item) => item.key === "modalDeductibleDepositContent"
    );

    const outOfHoursText = data?.find((item) => item.key === "OOhHourText");
    const includeTextData = data?.find((item) => item.key === "inCludeText");
    const customerIncludeData = data?.find(
      (item) => item.key === "includeDataText"
    );
    const customerNonIncludeData = data?.find(
      (item) => item.key === "isNonIncludedDataText"
    );
    const inCludedTitleData = data?.find(
      (item) => item.key === "inCludedTitle"
    );
    const nonInCludedTitleData = data?.find(
      (item) => item.key === "nonInCludedTitle"
    );
    setInCludedTitle(inCludedTitleData?.body || "");
    setNonInCludedTitle(nonInCludedTitleData?.body || "");
    setIsIncludedValue(
      customerIncludeData?.body ? customerIncludeData.body.split(",") : []
    );
    setIsNonIncludedValue(
      customerNonIncludeData?.body ? customerNonIncludeData.body.split(",") : []
    );
    setModalDeductibleDepositContent(
      modalDeductibleDepositData ? modalDeductibleDepositData.body : ""
    );
    setGroupFromTextResource(
      groupFromTextResourceData ? groupFromTextResourceData.body : ""
    );
    setVehicleCancelMsgLabel(
      vehicleCancellationMsg?.body ||
        translate(
          "Noleggla senza pensierl! Hai tempo fino al > data < percancellare la prenotazione senza costi aggiuntivi !"
        )
    );
    setSelectVehicleLabel(
      selectVehicleLabelData ? selectVehicleLabelData.body : ""
    );
    setNotAllowBookEndUserLabel(
      notAllowBookEndUserData ? notAllowBookEndUserData.body : ""
    );
    setCloseInfo(closeInfoData?.body || translate("Close"));
    setYoungDriverFeeLabel(
      YoungDriverTextData?.body
        .replace("extras_amount", `${VehicleDetails?.addedYoungDriverFee}`)
        .replace("currency", defaultCurrency || "€") || ""
    );
    setOohText(outOfHoursText?.body || "Out of hour fee");
    setIncludeText(includeTextData?.body || "Includes");

    const deliverySurchargeData = data?.find(
      (item) => item.key === "homeDeliverySurchargeLabel"
    );
    const returnSurchargeData = data?.find(
      (item) => item.key === "homeReturnSurchargeLabel"
    );
    setDeliverySurchargeLabel(
      deliverySurchargeData?.body || translate("Home Delivery Surcharge")
    );
    setReturnSurchargeLabel(
      returnSurchargeData?.body || translate("Home Return Surcharge")
    );

    const limitedVehicleText = data?.find(
      (item) => item.key === "VehicleWithLimited"
    );
    setVehicleLimitedAvailability(
      limitedVehicleText?.body ||
        t("Vehicle with limited availability - subjected to confirmation")
    );
  }, [lang, textResource, translate]);
  const showVehicleCancellationMsg = () => {
    setShowReservationCancelMessage(!showReservationCancelMessage);
  };
  useEffect(() => {
    setDiscount((100 - VehicleDetails.discount) / 100);
  }, [VehicleDetails.discount]);
  const [YoungDriverFeeLabel, setYoungDriverFeeLabel] = useState<String>("");
  const isSmallScreen = window.innerWidth <= 768;
  useEffect(() => {
    setTotalPrice(
      VehicleDetails.reservationSourcePayLater == "true"
        ? parseFloat(VehicleDetails.priceDetails.payNow)
        : parseFloat(VehicleDetails.priceDetails.payNow) * discount
    );
    setTotalPricePerDay(
      VehicleDetails.reservationSourcePayLater == "true"
        ? parseFloat(VehicleDetails.priceDetails.payNow) /
            (approximateDays == 0 ? 1 : approximateDays)
        : parseFloat(
            (
              parseFloat(VehicleDetails.priceDetails.payNow) * discount
            ).toString()
          ) / (approximateDays == 0 ? 1 : approximateDays)
    );
  }, [VehicleDetails.priceDetails]);

  const scrollToTop = () => {
    window.parent.postMessage(
      {
        event_id: "scrollToTop",
      },
      "*"
    );
  };
  const [searchParams] = useSearchParams();
  const scriptChannel = searchParams.get("scriptChannel") ?? "";
  const payNowDisAmount =
    VehicleDetails.reservationSourcePayLater == "true"
      ? 0
      : (parseFloat(VehicleDetails.priceDetails.payLater.toString()) *
          VehicleDetails.discount) /
        100;

  const [paymentType] = useState<"PAYNOW" | "PAYLATER" | "BOOK NOW" | "">();
  const [selectedFields] = useState<ChosenOptions>({
    insurance: undefined,
    options: {},
  });
  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  const textColorOfSelectedDriver = dynamicTheme?.palette["primary"]?.main;
  const textColorReservationCancel =
    dynamicTheme?.palette["backgroundColor"]?.main;
  const isShowOnRequestVehicles =
    appSettings?.showOnrequestVehicles &&
    VehicleDetails?.vehicleStatus?.toLowerCase() == "onrequest";

  const localeScalapay = (() => {
    try {
      const lang = i18n.language?.split("-")[0];
      return lang || "it";
    } catch (e) {
      return "it";
    }
  })();
  const isGretaBookingNewUi = appSettings?.isGretaBookingNewUi;
  function BookButton() {
    return (
      <AppButton
        disabled={status.toLowerCase() === "unavailable"}
        color="primary"
        className={`${
          isGretaBookingNewUi ? "" : "w-[6rem]"
        } h-[3rem] rounded-md`}
        style={{
          borderRadius: `${appSettings?.buttonBorderRadius || 0}px`,
          marginLeft: isGretaBookingNewUi ? "8px" : "",
        }}
        clickHandler={() => {
          window.scrollTo(0, 0);
          scrollToTop();
          VehicleDetails.moveToPayment({
            isPayLaterFee: false,
            extrasIncluded: false,
            extrasPrice: 0,
            payLaterFeeAmt: "",
            isDiscounted: payNowDisAmount,
            type: paymentType as "PAYNOW" | "PAYLATER",
            price: totalPrice,
            addedExtraOptions: selectedFields.options,
            selectedInsurance: selectedFields.insurance,
          });
        }}
      >
        <p
          className={`min-w-24 w-full h-full flex items-center justify-center text-${VehicleDetails.textColor} text-x capitalize font-normal`}
          style={{
            textTransform: "none",
          }}
        >
          {selectVehicleLabel ? (
            <div
              dangerouslySetInnerHTML={{
                __html: selectVehicleLabel,
              }}
            />
          ) : (
            <span>{t("Select")}</span>
          )}
        </p>
      </AppButton>
    );
  }
  const defaultCurrency = appSettings?.defaultCurrency;
  const isIpadMiniScreen = window.innerWidth >= 500 && window.innerWidth <= 780;
  const isDesktopScreen = window.innerWidth >= 1310;
  const vehicleCardHeightDesktop = appSettings?.vehicleCardParamHeightDesktop;
  const vehicleCardRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (vehicleCardRef.current) {
      const cardHeight = vehicleCardRef.current.offsetHeight || 0;
      if (updateTotalCardHeightMobile) {
        updateTotalCardHeightMobile(cardHeight);
      }
    }
  }, [vehicleCardRef]); // this is done to find out dynamic height of each card and sent it back to showVehicle page using callback function

  const addedOOHFee = VehicleDetails?.addedOOHFee && (
    <Grid item xs={12}>
      <Typography
        style={{
          fontWeight: "bold",
          fontSize: "small",
          textAlign: "left",
          color: textColorOfSelectedDriver,
        }}
      >
        {includeText} {defaultCurrency || "€"}
        {"  "}
        {VehicleDetails?.addedOOHFee} {oohText}
      </Typography>
    </Grid>
  );

  const addedOnwayFee = VehicleDetails?.addedOnewayFee && (
    <Grid item xs={12}>
      <Typography
        style={{
          fontWeight: "bold",
          fontSize: "small",
          textAlign: "left",
          color: textColorOfSelectedDriver,
        }}
      >
        Include {defaultCurrency || "€"}
        {"  "}
        {VehicleDetails?.addedOnewayFee?.toFixed(2)}{" "}
        {translate("of oneway Fee")}
      </Typography>
    </Grid>
  );

  const addedOnewayOOHFee = VehicleDetails?.addedOnewayOOHFee && (
    <Grid item xs={12}>
      <Typography
        style={{
          fontWeight: "bold",
          fontSize: "small",
          textAlign: "left",
          color: textColorOfSelectedDriver,
        }}
      >
        Include {defaultCurrency || "€"}
        {"  "}
        {VehicleDetails?.addedOnewayOOHFee} {translate("of oneway and OOH Fee")}
      </Typography>
    </Grid>
  );

  const addedYoungDriverFee = VehicleDetails?.addedYoungDriverFee && (
    <Grid item xs={12}>
      <Typography
        style={{
          fontWeight: "bold",
          fontSize: "small",
          textAlign: "left",
          color: textColorOfSelectedDriver,
        }}
      >
        {YoungDriverFeeLabel ||
          "Include" +
            " " +
            (defaultCurrency || "€") +
            " " +
            VehicleDetails?.addedYoungDriverFee +
            " " +
            translate("of Y_D fee")}
      </Typography>
    </Grid>
  );

  const addedYoungDriver2Fee = VehicleDetails?.addedYoungDriver2Fee && (
    <Grid item xs={12}>
      <Typography
        style={{
          fontWeight: "bold",
          fontSize: "small",
          textAlign: "left",
          color: textColorOfSelectedDriver,
        }}
      >
        Include {defaultCurrency || "€"}
        {"  "}
        {VehicleDetails?.addedYoungDriver2Fee} {translate("of Y_D_2 fee")}
      </Typography>
    </Grid>
  );

  const addedSeniorDriverFee = VehicleDetails?.addedSeniorDriverFee && (
    <Grid item xs={12}>
      <Typography
        style={{
          fontWeight: "bold",
          fontSize: "small",
          textAlign: "left",
          color: textColorOfSelectedDriver,
        }}
      >
        Include {defaultCurrency || "€"}
        {"  "}
        {VehicleDetails?.addedSeniorDriverFee} {translate("of S_D fee")}
      </Typography>
    </Grid>
  );
  const addedNoAgeFee = VehicleDetails?.addedNoAgeFee && (
    <Grid item xs={12}>
      <Typography
        style={{
          fontWeight: "bold",
          fontSize: "small",
          textAlign: "left",
          color: textColorOfSelectedDriver,
        }}
      >
        Include {defaultCurrency || "€"}
        {VehicleDetails?.addedNoAgeFee} {translate("of No age fee")}
      </Typography>
    </Grid>
  );

  const deliverySurchargeItem = VehicleDetails?.deliverySurchargeAmount !=
    null &&
    VehicleDetails.deliverySurchargeAmount > 0 && (
      <Grid item xs={12}>
        <Typography
          style={{
            fontWeight: "bold",
            fontSize: "small",
            textAlign: "left",
            color: textColorOfSelectedDriver,
          }}
        >
          {defaultCurrency || "€"}{" "}
          {VehicleDetails.deliverySurchargeAmount?.toFixed(2)}{" "}
          {deliverySurchargeLabel}
        </Typography>
      </Grid>
    );

  const returnSurchargeItem = VehicleDetails?.returnSurchargeAmount != null &&
    VehicleDetails.returnSurchargeAmount > 0 && (
      <Grid item xs={12}>
        <Typography
          style={{
            fontWeight: "bold",
            fontSize: "small",
            textAlign: "left",
            color: textColorOfSelectedDriver,
          }}
        >
          {defaultCurrency || "€"}{" "}
          {VehicleDetails.returnSurchargeAmount?.toFixed(2)}{" "}
          {returnSurchargeLabel}
        </Typography>
      </Grid>
    );

  const allImages = Array.from(
    new Set([
      ...(VehicleDetails?.vehicleExtraImage || []),
      ...(VehicleDetails?.vehicleImages || []),
    ])
  );

  // Ensure selectedImage is valid
  const safeSelectedImage = Math.min(selectedImage, allImages.length - 1);

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const handleTouchStart = (e: { touches: { clientX: number }[] }) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e: { touches: { clientX: number }[] }) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;

    if (Math.abs(diff) > 50) {
      // Swipe
      if (diff > 0) {
        // Swiped left → next image
        setSelectedImage((prev) =>
          prev === allImages.length - 1 ? 0 : prev + 1
        );
      } else {
        // Swiped right → previous image
        setSelectedImage((prev) =>
          prev === 0 ? allImages.length - 1 : prev - 1
        );
      }
    }
  };
  const vehicleCodeFromUrl = searchParams.get("vehicleInternationalCode");
  const vehicleStatusParam = searchParams.get("vehicleStatus");
  const vehicleStatus =
    vehicleStatusParam &&
    vehicleStatusParam !== "Available" &&
    vehicleStatusParam !== "OnRequest";

  useEffect(() => {
    if (
      vehicleCodeFromUrl &&
      vehicleCodeFromUrl == vehicleInternationalCode &&
      appSettings?.showAllDetailsOfVehicleCardInInfoBtn &&
      isNotclickedEdit
    ) {
      scrollToTop();
      setOpenModal(true);
    }
  }, [searchParams, vehicleInternationalCode, isNotclickedEdit]);
  function handleClose() {
    setOpenModal(false);
    setIsVehicleUnavQuot(false);
    if (vehicleStatus) {
      const newParams = new URLSearchParams(searchParams.toString());
      newParams.delete("vehicleInternationalCode");
      newParams.delete("vehicleStatus");

      const newUrl =
        window.location.pathname +
        (newParams.toString() ? `?${newParams.toString()}` : "");
      window.location.href = newUrl.toString();
    }
  }
  function closeModal() {
    setOpenModal(false);
  }

  const showForScriptChannel =
    (scriptChannel &&
      ((VehicleDetails?.showScalapayWidgetPayNow && paymentType == "PAYNOW") ||
        (VehicleDetails?.showScalapayWidgetPayLater &&
          paymentType == "PAYLATER"))) ||
    (VehicleDetails?.reservationSourcePayNow == "true" &&
      VehicleDetails?.showScalapayWidgetPayNow) ||
    (VehicleDetails?.reservationSourcePayLater == "true" &&
      VehicleDetails?.showScalapayWidgetPayLater);

  const showForNonScriptChannel =
    scriptChannel == "" &&
    VehicleDetails?.reservationSourcePayNow === "false" &&
    VehicleDetails?.reservationSourcePayLater === "false" &&
    (VehicleDetails?.showScalapayWidgetPayNow === true ||
      VehicleDetails?.showScalapayWidgetPayLater === true);
  const shouldShowScalapayWidget =
    !isReservedAreaUser && (showForScriptChannel || showForNonScriptChannel);

  return (
    <section
      className="hover:drop-shadow-lg cursor-pointer rounded-tl-[32px] relative flex flex-col bg-white box-border text-[#004188] z-12 shadow-md"
      style={{
        backgroundColor: VehicleDetails.backgroundColor,
        borderTopRightRadius: appSettings?.vehicleCardRoundEdge
          ? "32px"
          : "0px",
        borderBottomRightRadius: appSettings?.vehicleCardRoundEdge
          ? "32px"
          : "12px",
        borderBottomLeftRadius: appSettings?.vehicleCardRoundEdge
          ? "32px"
          : "12px",
        // width: appSettings?.showThreeVehicleCardInArow ? "90%" : "100%",
      }}
      ref={vehicleCardRef}
    >
      <header
        className={`text-black w-full flex flex-col p-2 ${
          isGretaUi && isSmallScreen ? "" : "px-4"
        } bg-[#ffffff] rounded-tl-[32px] rounded-br-[32px]`}
        style={{
          borderTopRightRadius: appSettings?.vehicleCardRoundEdge
            ? "32px"
            : "0px",
          borderBottomLeftRadius: appSettings?.vehicleCardRoundEdge
            ? "32px"
            : "0px",
          borderWidth:
            process.env.REACT_APP_COMPANY_CODE !== "updrive" &&
            process.env.REACT_APP_COMPANY_CODE !== "felirent"
              ? "2px"
              : "0px",
        }}
      >
        <aside>
          <div
            className={"flex flex-row"}
            style={{
              height: !isSmallScreen
                ? `${vehicleCardHeightDesktop || 226}px`
                : "auto",
              justifyContent: "space-between",
            }}
          >
            <div
              className="h-full p-2"
              style={{ width: isSmallScreen ? "70%" : "68%" }}
            >
              <div>
                {groupFromTextResource ? (
                  <div
                    style={{ paddingBottom: "24px" }}
                    dangerouslySetInnerHTML={{
                      __html: groupFromTextResource,
                    }}
                  />
                ) : (
                  <>
                    <div
                      className="box-border capitalize"
                      style={{
                        textAlign: "left",
                        fontWeight: "normal",
                        fontSize: "small",
                      }}
                    >
                      <span>
                        {"Gruppo"} {VehicleDetails?.vehicleGroup}{" "}
                      </span>
                    </div>
                    <div
                      className="box-border capitalize font-bold"
                      style={{ textAlign: "left" }}
                    >
                      <span
                        style={{
                          textTransform: "none",
                        }}
                      >
                        {VehicleDetails?.vehicleName}
                      </span>
                    </div>
                    <div
                      className="box-border text-sm capitalize"
                      style={{
                        textAlign: "left",
                        fontWeight: "normal",
                        fontSize: "x-small",
                      }}
                    >
                      <span>
                        {VehicleDetails?.vehicleName
                          ?.split(" or ")[1]
                          ?.toLowerCase()}{" "}
                      </span>
                    </div>
                  </>
                )}
              </div>
              <div
                style={{
                  marginTop: "8px",
                  marginBottom: "8px",
                  paddingTop:
                    process.env.REACT_APP_COMPANY_CODE === "noleggiago" ||
                    process.env.REACT_APP_COMPANY_CODE === "updrive"
                      ? "15px"
                      : "",
                }}
              >
                {VehicleDetails?.specifications &&
                VehicleDetails.specifications.length > 0 ? (
                  VehicleDetails.specifications.map((el, index) => (
                    <div
                      key={index}
                      style={{ flexBasis: "calc(33.33% - 8px)" }}
                    >
                      <VehicleSpecsCard {...el} />
                    </div>
                  ))
                ) : (
                  <div
                    style={{
                      flexBasis: "calc(33.33% - 8px)",
                      visibility: "hidden",
                    }}
                  ></div>
                )}
              </div>
            </div>
            <div className="w-full h-full p-2">
              <div style={{ float: "right" }}>
                <Button onClick={toogleVehicleInfoCardShowingStatus}>
                  <p
                    className="text-md capitalize"
                    style={{
                      color: VehicleDetails.backgroundTextColor,
                    }}
                  >
                    {vehicleInfoLabel ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: vehicleInfoLabel,
                        }}
                      />
                    ) : appSettings?.showAllDetailsOfVehicleCardInInfoBtn ? (
                      <InfoIcon
                        sx={{
                          color: dynamicTheme?.palette["secondaryColor"]?.main,
                        }}
                      />
                    ) : (
                      <span>{t("Info")}</span>
                    )}
                    {/*(*/}
                    {/*// <span>{t("Info")}</span>*/}
                    {/*)}*/}
                  </p>
                </Button>
              </div>
              <div className="w-full flex flex-col items-center justify-center flex-grow">
                <img
                  src={allImages[safeSelectedImage] ?? ""}
                  alt="vehicle"
                  className="w-38 h-48 object-contain"
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}
                />

                {/* Dots navigation */}
                <div className="flex space-x-2 mb-3 justify-center items-center">
                  {allImages.length > 1 && (
                    <>
                      {allImages.map((_, index) => (
                        <button
                          key={index}
                          onClick={() => setSelectedImage(index)}
                          className={`w-[6px] h-[6px] rounded-full transition ${
                            index === safeSelectedImage
                              ? "bg-black"
                              : "bg-gray-300"
                          }`}
                        />
                      ))}
                    </>
                  )}
                </div>
              </div>
              {isVehicleUnavQuot &&
                isFromShareLink &&
                appSettings?.showAllDetailsOfVehicleCardInInfoBtn && (
                  <Dialog
                    open={isVehicleUnavQuot}
                    onClose={handleClose}
                    maxWidth="md"
                    fullWidth
                    sx={{
                      "& .MuiDialog-container": {
                        alignItems: "flex-start",
                        paddingTop: "20px",
                      },
                    }}
                    PaperProps={{
                      style: {
                        borderRadius: 20,
                        overflow: "hidden",
                        width: "100%",
                        height: isSmallScreen
                          ? "650px"
                          : scalapayWidgetVisible
                          ? "600px"
                          : "500px",
                        maxHeight: "90vh",
                      },
                    }}
                  >
                    <CarDetailsPopup
                      onClose={handleClose}
                      dynamicTheme={dynamicTheme}
                      vehicleInternationalCode={vehicleInternationalCode}
                      closeModal={closeModal}
                      isVehicleUnavQuot={isVehicleUnavQuot}
                      setIsLoading={setIsLoading}
                      scriptChannel={scriptChannel}
                      localeScalapay={localeScalapay}
                      onScalapayWidgetChange={setScalapayWidgetVisible}
                    />
                  </Dialog>
                )}
              {/* Modal popup in the center */}
              {openModal &&
                appSettings?.showAllDetailsOfVehicleCardInInfoBtn &&
                (!isVehicleUnavQuot || !isFromShareLink) && (
                  <Dialog
                    open={openModal}
                    onClose={handleClose}
                    maxWidth="md"
                    fullWidth
                    sx={{
                      "& .MuiDialog-container": {
                        alignItems: "flex-start",
                        paddingTop: "20px",
                      },
                    }}
                    PaperProps={{
                      style: {
                        borderRadius: 20,
                        overflow: "hidden",
                        width: "100%",
                        height: isSmallScreen
                          ? "650px"
                          : scalapayWidgetVisible
                          ? "600px"
                          : "500px",
                        maxHeight: "90vh",
                      },
                    }}
                  >
                    <CarDetailsPopup
                      VehicleDetails={VehicleDetails}
                      onClose={handleClose}
                      dynamicTheme={dynamicTheme}
                      totalPricePerDay={totalPricePerDay}
                      modalTechnicalDataContent={modalTechnicalDataContent}
                      modalDeductibleDepositContent={
                        modalDeductibleDepositContent
                      }
                      paymentType={paymentType}
                      totalPrice={totalPrice}
                      selectedFields={selectedFields}
                      payNowDisAmount={payNowDisAmount}
                      vehicleInternationalCode={vehicleInternationalCode}
                      closeModal={closeModal}
                      setIsLoading={setIsLoading}
                      scriptChannel={scriptChannel}
                      localeScalapay={localeScalapay}
                      onScalapayWidgetChange={setScalapayWidgetVisible}
                    />
                  </Dialog>
                )}
            </div>
          </div>
          <div className="w-full h-full ">
            <div
              className="relative w-full"
              style={{
                minHeight: "100px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                padding: "10px 12px 12px 12px",
                marginRight: isGretaBookingNewUi ? "10px" : "",
              }}
            >
              {VehicleDetails?.notAllowBookEndUser ? (
                <div
                  className="box-border text-[13px] flex flex-row text-gray-600 capitalize font-bold w-full"
                  style={{
                    color: "rgba(0, 0, 0, 0.6)",
                    textAlign: "left",

                    marginTop: "25px",
                    marginBottom: "25px",
                    justifyContent: "space-between",
                  }}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: notAllowBookEndUserLabel,
                    }}
                  />
                </div>
              ) : (
                <>
                  <div
                    className="flex flex-row w-full h-full"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div
                      className="box-border text-sm capitalize w-full h-full"
                      style={{ textAlign: "left" }}
                    >
                      {(() => {
                        const amountDetails = formatPriceWithCurrencySymbol(
                          currency,
                          actualPrice
                        );
                        const discountedAmountDetails =
                          formatPriceWithCurrencySymbol(
                            currency,
                            totalPricePerDay
                          );
                        const isDiscountAndMobile =
                          VehicleDetails.isDiscountApplied && isSmallScreen;
                        return (
                          <>
                            <span className="main-price text-2xl text-md">
                              <div
                                style={{
                                  display: isDiscountAndMobile
                                    ? "flex"
                                    : !VehicleDetails.isDiscountApplied ||
                                      !isDesktopScreen
                                    ? "inline-flex"
                                    : undefined,
                                  flexDirection: isDiscountAndMobile
                                    ? "column"
                                    : undefined,
                                  alignItems: !isDiscountAndMobile
                                    ? "center"
                                    : undefined,
                                }}
                              >
                                {VehicleDetails.isDiscountApplied && (
                                  <p
                                    className="original-price text-gray-500 line-through"
                                    style={{
                                      marginRight: isSmallScreen
                                        ? "0px"
                                        : "8px",
                                      color:
                                        dynamicTheme?.palette["primary"]?.main,
                                      fontSize: isSmallScreen
                                        ? "0.8em"
                                        : "0.9em",
                                      fontWeight: "700",
                                      width: isDiscountAndMobile
                                        ? "100%"
                                        : isSmallScreen
                                        ? "39%"
                                        : "",
                                      paddingLeft: isDesktopScreen
                                        ? "7.5px"
                                        : undefined,
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontWeight: "700",
                                        fontSize:
                                          isSmallScreen &&
                                          amountDetails.price.length > 7
                                            ? ".79em"
                                            : undefined,
                                      }}
                                    >
                                      {(defaultCurrency ||
                                        amountDetails.symbol) +
                                        " " +
                                        amountDetails.price}
                                    </span>
                                    <span
                                      className="font-normal h-full"
                                      style={{
                                        fontWeight: "400",
                                        textTransform: "none",
                                      }}
                                    >
                                      {translate("/day")}
                                    </span>
                                  </p>
                                )}
                                <p
                                  className="discounted-price whitespace-nowrap text-black"
                                  style={{
                                    paddingLeft:
                                      !VehicleDetails.isDiscountApplied ||
                                      isDesktopScreen
                                        ? "7.5px"
                                        : undefined,
                                    width:
                                      VehicleDetails.isDiscountApplied &&
                                      isSmallScreen
                                        ? "100%"
                                        : "",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize:
                                        VehicleDetails.isDiscountApplied &&
                                        isSmallScreen
                                          ? "1em"
                                          : "1.1em",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {(defaultCurrency ||
                                      discountedAmountDetails.symbol) +
                                      " " +
                                      discountedAmountDetails.price}
                                  </span>
                                  <span
                                    className="font-normal h-full"
                                    style={{
                                      fontSize:
                                        VehicleDetails.isDiscountApplied &&
                                        isSmallScreen
                                          ? ".8rem"
                                          : "1rem",
                                      fontWeight: "400",
                                      textTransform: "none",
                                    }}
                                  >
                                    {translate("/day")}
                                  </span>
                                </p>
                              </div>
                            </span>
                            {isSmallScreen && <br />}
                          </>
                        );
                      })()}

                      {(() => {
                        const amountDetails = formatPriceWithCurrencySymbol(
                          currency,
                          totalPrice
                        );
                        return (
                          <span
                            className="total-price text-[#707070] whitespace-nowrap font-normal"
                            style={{
                              fontSize: "x-small",

                              paddingLeft: "7.5px",
                            }}
                          >
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                            >
                              {VehicleDetails.isDiscountApplied && (
                                <p
                                  className="original-price text-gray-500 line-through"
                                  style={{
                                    marginRight: "8px",
                                    color:
                                      dynamicTheme?.palette["primary"]?.main,
                                  }}
                                >
                                  {(defaultCurrency || amountDetails.symbol) +
                                    (VehicleDetails.reservationSourcePayLater ==
                                    "true"
                                      ? parseFloat(
                                          VehicleDetails.actualPrice.toString()
                                        )
                                      : parseFloat(
                                          VehicleDetails.actualPrice.toString()
                                        ) * discount
                                    ).toFixed(2)}
                                </p>
                              )}
                              {(defaultCurrency || amountDetails.symbol) + " "}
                            </span>
                            <span>{amountDetails.price}</span>
                            <span>totale per periodo</span>
                            {appSettings?.vehicleReservationCancelMessage && (
                              <p
                                className="text-md font-bold px-1 relative"
                                style={{
                                  color: textColorOfSelectedDriver,
                                }}
                              >
                                <b>Cancella gratuitamente</b>
                                <span
                                  onClick={showVehicleCancellationMsg}
                                  className="rounded-full p-[.15rem] cursor-pointer"
                                  style={{
                                    lineHeight: "24px",
                                    backgroundColor: textColorOfSelectedDriver,
                                    marginLeft: "3px",
                                    paddingRight: "5px",
                                    color: textColorReservationCancel,
                                  }}
                                >
                                  {" ?"}
                                </span>
                                {showReservationCancelMessage && (
                                  <div
                                    className="absolute left-[118%] transform -translate-x-1/2 -top-[6.75rem] w-auto max-w-xs p-3 rounded-md z-10 "
                                    style={{
                                      width: "150%",
                                      height: "auto",
                                      backgroundColor:
                                        textColorOfSelectedDriver,
                                    }}
                                  >
                                    <p
                                      className="break-words whitespace-normal"
                                      style={{
                                        color: textColorReservationCancel,
                                      }}
                                    >
                                      {vehicleCancelMsgLabel}
                                    </p>
                                  </div>
                                )}
                              </p>
                            )}
                          </span>
                        );
                      })()}
                    </div>
                    <div
                      style={{
                        float: "right",
                      }}
                    >
                      <p
                        className="text-[primary] text-md capitalize font-bold"
                        style={{
                          paddingTop:
                            isDesktopScreen && VehicleDetails.isDiscountApplied
                              ? "21px"
                              : undefined,
                        }}
                      >
                        <BookButton />
                      </p>
                    </div>
                  </div>

                  <div
                    className="flex flex-row mt-2 w-full h-full"
                    style={{ textAlign: "left" }}
                  >
                    {isDesktopScreen ? (
                      <div
                        className="box-border text-[13px] text-gray-600 font-bold w-full h-full"
                        style={{
                          color:
                            process.env.REACT_APP_COMPANY_CODE === "felirent"
                              ? "red"
                              : "rgba(0, 0, 0, 0.6)",
                          textAlign: "left",

                          opacity: isShowOnRequestVehicles ? "1" : "0",
                        }}
                      >
                        {vehicleLimitedAvailability}
                      </div>
                    ) : (
                      isShowOnRequestVehicles && (
                        <div
                          className="box-border text-[13px] text-gray-600 font-bold"
                          style={{
                            color:
                              process.env.REACT_APP_COMPANY_CODE === "felirent"
                                ? "red"
                                : "rgba(0, 0, 0, 0.6)",
                            textAlign: "left",
                          }}
                        >
                          {vehicleLimitedAvailability}
                        </div>
                      )
                    )}
                  </div>
                  {appSettings?.showIsVatIncludedMsg && (
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "small",
                        textAlign: "left",
                        color: "red",
                      }}
                    >
                      <p>{translate("The rates are VAT included")}</p>
                    </div>
                  )}
                  {addedOOHFee ||
                    addedOnwayFee ||
                    addedOnewayOOHFee ||
                    addedYoungDriverFee ||
                    addedYoungDriver2Fee ||
                    addedSeniorDriverFee ||
                    addedNoAgeFee}
                  {deliverySurchargeItem}
                  {returnSurchargeItem}
                </>
              )}
            </div>
            {shouldShowScalapayWidget && (
              <div style={{ paddingTop: "5px" }}>
                <hr style={{ border: ".3px solid #ccc" }} />
                <div
                  style={{
                    paddingTop: "4px",
                    fontSize: "12px",
                    color: "#000",
                  }}
                >
                  <scalapay-widget
                    locale={localeScalapay}
                    channel="travel"
                    amount={totalPrice.toFixed(2)}
                    type="product"
                    merchant-token={VehicleDetails?.scalapayMerchantToken}
                    {...(VehicleDetails?.scalapayEnvVal
                      ? { environment: VehicleDetails?.scalapayEnvVal }
                      : {})}
                  />
                </div>
              </div>
            )}
          </div>
        </aside>
      </header>

      {showInfo && appSettings?.vehicleInfoChoice == "baseExcessAndDepositVal" && (
        <div
          style={{ overflowY: "auto" }}
          className="hover:drop-shadow-lg cursor-pointer rounded-tl-[32px] rounded-br-[32px] rounded-tr-[32px] rounded-bl-[32px] h-full w-full absolute bg-white p-4 z-10 top-0 left-0 animate__animated animate__zoomIn"
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="w-full flex justify-end">
              <Button
                style={{
                  color: VehicleDetails.backgroundTextColor,
                }}
                onClick={() => {
                  toogleVehicleInfoCardShowingStatus();
                }}
              >
                {appSettings?.hideCloseLabelWithCrossIcon ? (
                  <div
                    className="cross-icon"
                    style={
                      {
                        "--cross-color":
                          dynamicTheme?.palette["secondaryColor"]?.main,
                      } as React.CSSProperties
                    }
                  />
                ) : (
                  <span>{closeInfo}</span>
                )}
              </Button>
            </div>
            <div className="h-fit flex flex-row flex-wrap w-fit gap-12 ml-4">
              {/*<span className="h-fit flex items-left text-black md:text-md text-md">*/}
              {/*  {"Base Excess Value"}*/}
              {/*</span>*/}
            </div>
            <div className="h-fit items-left flex-wrap w-fit gap-12 ml-4 my-2">
              <span className="items-left font-light text-black md:text-md text-md">
                {appSettings && !appSettings?.hideTheftAmountInInfo && (
                  <p className="my-2 flex items-left">
                    {translate("theft.excess.amount")}{" "}
                    <span className="mx-4" style={{ fontWeight: "bold" }}>
                      {appSettings?.showTheftExcessPercentage &&
                      VehicleDetails?.theftExcessPercentage
                        ? `${VehicleDetails.theftExcessPercentage}%`
                        : `€${VehicleDetails?.theftExcessAmount}`}
                    </span>
                  </p>
                )}
                {appSettings && !appSettings?.hideDamageAmountInInfo && (
                  <p className="my-2 flex items-left">
                    {translate("damage.excess.amount")}
                    <span className="mx-4" style={{ fontWeight: "bold" }}>
                      {"€"}
                      {VehicleDetails?.damageExcessAmount}
                    </span>
                  </p>
                )}
                {appSettings && !appSettings?.hideDepositAmountInInfo && (
                  <p className="flex items-left">
                    {translate("deposit.excess.amount")}
                    <span className="mx-4" style={{ fontWeight: "bold" }}>
                      {defaultCurrency || "€"}{" "}
                      {VehicleDetails?.DepositAmount
                        ? VehicleDetails.DepositAmount
                        : VehicleDetails?.depositAmtFromOpt}
                    </span>
                  </p>
                )}
              </span>
            </div>
          </div>
        </div>
      )}
      {showInfo && appSettings?.vehicleInfoChoice == "includedOptional" && (
        <div
          style={{ overflowY: "auto" }}
          className="hover:drop-shadow-lg cursor-pointer rounded-tl-[32px] rounded-tr-[32px] rounded-br-[32px] rounded-bl-[32px] h-full w-full absolute bg-white p-4 z-10 top-0 left-0 animate__animated animate__zoomIn"
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="w-full flex justify-end">
              <Button
                style={{
                  color: VehicleDetails.backgroundTextColor,
                }}
                onClick={() => {
                  toogleVehicleInfoCardShowingStatus();
                }}
              >
                {appSettings?.hideCloseLabelWithCrossIcon ? (
                  <div
                    className="cross-icon"
                    style={
                      {
                        "--cross-color":
                          dynamicTheme?.palette["secondaryColor"]?.main,
                      } as React.CSSProperties
                    }
                  />
                ) : (
                  <span>{closeInfo}</span>
                )}
              </Button>
            </div>
            <div className="h-fit flex flex-row flex-wrap w-fit gap-12 ml-4">
              {(() => {
                const extras = VehicleDetails.extras;
                const included: string[] = [];
                const notIncluded: string[] = [];

                extras.forEach((el) => {
                  if (
                    el.Charge.IncludedInRate &&
                    el.Charge.Description != null
                  ) {
                    included.push(el.Charge.Description);
                  } else if (el.Charge.Description != null) {
                    notIncluded.push(el.Charge.Description);
                  }
                });

                return (
                  <>
                    <span className="font-light text-gray-600 text-sm text-left">
                      <h2
                        className="text-md font-bold"
                        style={{ color: VehicleDetails.backgroundTextColor }}
                      >
                        {(Array.isArray(isIncludedValue) &&
                          isIncludedValue.length > 0) ||
                        included.length > 0 ? (
                          <span>
                            {Array.isArray(isIncludedValue) &&
                            isIncludedValue.length > 0 ? (
                              <span style={{ fontWeight: 300 }}>
                                {inCludedTitle}:
                              </span>
                            ) : (
                              translate("Including")
                            )}
                          </span>
                        ) : null}
                      </h2>
                      <br></br>
                      {Array.isArray(isIncludedValue) &&
                      isIncludedValue.length > 0
                        ? isIncludedValue.map((val, index) => (
                            <div key={index}>
                              <h3>
                                <span style={{ fontSize: "1.8rem" }}>•</span>{" "}
                                {val}
                              </h3>
                            </div>
                          ))
                        : included.map((val, index) => (
                            <div key={index}>
                              <h3>{val}</h3>
                            </div>
                          ))}
                    </span>
                    <span className="font-light text-gray-600 text-sm text-left">
                      <h2
                        className="text-md text-[#17A1B7] font-bold"
                        style={{ color: VehicleDetails.backgroundTextColor }}
                      >
                        {(Array.isArray(isNonIncludedValue) &&
                          isNonIncludedValue.length > 0) ||
                        notIncluded.length > 0 ? (
                          <span>
                            {Array.isArray(isNonIncludedValue) &&
                            isNonIncludedValue.length > 0 ? (
                              <span style={{ fontWeight: 300 }}>
                                {nonInCludedTitle}:
                              </span>
                            ) : (
                              translate("Not Including")
                            )}
                          </span>
                        ) : null}
                      </h2>
                      <br></br>
                      {Array.isArray(isNonIncludedValue) &&
                      isNonIncludedValue.length > 0
                        ? isNonIncludedValue.map((val, index) => (
                            <div key={index}>
                              <span style={{ fontSize: "1.8rem" }}>•</span>{" "}
                              {val}
                            </div>
                          ))
                        : notIncluded.map((val, index) => (
                            <div key={index}>{val}</div>
                          ))}
                    </span>
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      )}
      {showInfo && appSettings?.vehicleInfoChoice == "vehicleParameters" && (
        <div
          style={{ overflowY: "auto" }}
          className="hover:drop-shadow-lg cursor-pointer rounded-tl-[32px] rounded-br-[32px] rounded-tr-[32px] rounded-bl-[32px] h-full w-full absolute bg-white p-4 z-10 top-0 left-0 animate__animated animate__zoomIn"
        >
          <div>
            <div className="w-full flex justify-end">
              <Button
                style={{
                  color: VehicleDetails.backgroundTextColor,
                }}
                onClick={() => {
                  toogleVehicleInfoCardShowingStatus();
                }}
              >
                {appSettings?.hideCloseLabelWithCrossIcon ? (
                  <div
                    className="cross-icon"
                    style={
                      {
                        "--cross-color":
                          dynamicTheme?.palette["secondaryColor"]?.main,
                      } as React.CSSProperties
                    }
                  />
                ) : (
                  <span>{closeInfo}</span>
                )}
              </Button>
            </div>
            {VehicleDetails.specifications.map((el, index) => {
              return (
                <div
                  key={index}
                  style={{ flexBasis: "calc(33.33% - 8px)" }} // Adjust the flex basis to create a 3-column layout
                >
                  <VehicleSpecification {...el} />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </section>
  );
}

function VehicleSpecsCard({ iconUrl, name }: VehicleSpecsCardProps) {
  return (
    <div className="w-full min-w-fit flex flex-row gap-2 items-center">
      {iconUrl && (
        <img
          src={iconUrl}
          alt={iconUrl}
          style={{
            height:
              process.env.REACT_APP_COMPANY_CODE === "updrive"
                ? "0.75rem"
                : "1.25rem",
            width:
              process.env.REACT_APP_COMPANY_CODE === "updrive"
                ? "0.75rem"
                : "1.25rem",
          }}
        />
      )}
      <span
        className="font-light text-black"
        style={{
          fontSize: "x-small",
          textAlign: "left",
          paddingTop:
            process.env.REACT_APP_COMPANY_CODE === "updrive" ? "0px" : "3px",
          flex: "1",
          marginTop:
            process.env.REACT_APP_COMPANY_CODE === "updrive" ? "5px" : "8px",
        }}
      >
        {name}
      </span>
    </div>
  );
}

export default VehicleCardPitView;
